import Vue from 'vue'
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/es'
import vueSmoothScroll from 'vue2-smooth-scroll'
import VueScrollactive from 'vue-scrollactive'
import VueMeta from 'vue-meta'
import VueSweetalert2 from 'vue-sweetalert2'

import Maska from 'maska'

import vSelect from 'vue-select'
import router from './router'
import store from './store'
import App from './App.vue'

// Global Components
import './global-components'

import './@core/utils/validations/validations'

// 3rd party plugins
import '@/libs/portal-vue'
import '@/libs/toastification'
import '@/libs/sweet-alerts'
import '@/assets/scss/variables/element-variables.scss'
import 'element-ui/lib/theme-chalk/index.css'

// import '@/assets/styles/sass/themes/lite-purple.scss'
// import '@/assets/styles/css/landing.css'

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)
Vue.use(VueSweetalert2)
Vue.use(vSelect)
Vue.use(Maska)

// Composition API
Vue.use(VueCompositionAPI)

// Element UI
Vue.use(ElementUI, { locale })

// Vue Scrollactive
Vue.use(VueScrollactive)
Vue.use(vueSmoothScroll)

// Vue Meta
Vue.use(VueMeta, {
  keyName: 'metaInfo',
  attribute: 'data-vue-meta',
  ssrAttribute: 'data-vue-meta-server-rendered',
  tagIDKeyName: 'vmid',
  refreshOnceOnNavigation: true,
})

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
